module.exports = __webpack_public_path__ + "media/images/img-cindy-3595461f9ad01d42c4ca5abbfb6988e0.jpg";